import Components from "slotworks/components/components";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import { sequence, parallel } from "slotworks/utils/race-utils";
import Layers from "slotworks/graphics/layers/layers";
import * as TweenJS from "slotworks/utils/tween";
import gameState from "slotworks/model/game-state";
import RainbowStacksFreespinRecord from "integration/revolver/schema/freespin-record";
import Timer from "slotworks/utils/timer";
import soundManager from "slotworks/sound/sound-manager";

export default class RSRetriggerFreespins extends State {

    private static MOVE_TIME = 600;
    private static Y_MOTION = 800;
    
    public onEnter() {
        this.moveRetriggers().then(() => this.complete());
    }

    public complete() {
        this.clean();

        super.complete();
    }

    private moveRetriggers() {
        return new Contract(resolve => {
            const position = Layers.Custom.get("Animations").getPosition("freespins");
            const scatters = Components.matrix.getGridSymbols().filter(symbol => symbol.symbolId == "SC");
            const funcs = [];
            let index = 0;

            for(const symbol of scatters) {
                const name = "sc_text_" + symbol.gridPosition.x + "_" + symbol.gridPosition.y;
                const text = Layers.Custom.get("Animations").getText(name);
                const filterName = "sc_filter_" + symbol.gridPosition.x + "_" + symbol.gridPosition.y;
                const filter = Layers.Custom.get("Animations").getSprite(filterName);
                const delay = index * 300;
                index++;

                if(text) {
                    funcs.push(() => new Contract(resolve => {
                        if(filter) {
                            new TweenJS.Tween(filter)
                            .to({alpha: 0}, 300)
                            .onComplete(() => {
                                Layers.Custom.get("Animations").remove(filter);
                                filter.destroy();
                            })
                            .start();
                        }
                        new TweenJS.Tween(text)
                        .to({x: position.x, y: [position.y - RSRetriggerFreespins.Y_MOTION - Math.random() * 400, position.y + 100]}, RSRetriggerFreespins.MOVE_TIME)  
                        .interpolation(TweenJS.Interpolation.Bezier) 
                        .delay(delay)
                        .onComplete(() => {
                            Layers.Custom.get("Animations").remove(text);
                            text.destroy();
                            resolve(null);
                        })
                        .start();
                        Timer.setTimeout(() => soundManager.customEvent("fs_add_one"), (delay + RSRetriggerFreespins.MOVE_TIME - 400));
                    }));
                }
            }

            parallel(funcs).then(() => {
                this.updateSpins();
                Timer.setTimeout(resolve, 500);
            });
        });
    }

    private updateSpins() {
        const record = gameState.getCurrentGame().getCurrentRecord() as RainbowStacksFreespinRecord;
        Components.betBar.setRemainingFreespins(Math.max(0, record.remainingFreespins));
        Components.betBar.setTotalFreespins(record.totalFreespins);
    }

    private clean() {
        // fix for concurrency problem when the game is in background
        const remove = [];
        for(let obj of Layers.Custom.get("Animations").container.children) {
            if(obj.name && (obj.name.includes("sc_text_") ||  obj.name.includes("sc_filter_"))) {
                remove.push(obj);
            }
        }

        for(let obj of remove) {
            Layers.Custom.get("Animations").container.removeChild(obj);
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/retrigger-freespins.ts